import React from 'react';

import { SVGIconType } from '../../../constants/svgIcon';
import { getWebPageVariant, WebPageType } from '../../../constants/webPageType';
import { SvgIcon } from '../SVGIcon';

import styles from './CircleCheckbox.module.css';

export type CircleCheckboxProps = {
  checked: boolean;
  onChange?: (checked: boolean) => void;
  disabled?: boolean;
  webPageType: WebPageType;
};

export const CircleCheckbox: React.FC<CircleCheckboxProps> = ({
  checked,
  onChange,
  disabled = false,
  webPageType,
}) => {
  const handleToggle = () => {
    if (!disabled && onChange) {
      onChange(!checked);
    }
  };

  return (
    <div
      className={`${styles.checkbox} ${disabled ? styles.disabled : ''}`}
      onClick={(e) => {
        if (onChange) {
          e.stopPropagation();
          handleToggle();
        }
      }}
    >
      {checked ? (
        <SvgIcon
          name={getWebPageVariant(webPageType).circleTick}
          width={24}
          height={24}
          color="white"
        />
      ) : (
        <SvgIcon
          name={SVGIconType.CircleCheckboxEmpty}
          width={24}
          height={24}
          color="#808080"
        />
      )}
    </div>
  );
};
